import Resource from 'components/global/Resource'
import SectionTitle from 'components/global/SectionTitle'
import { Section, Row, Col } from 'components/grid'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'
import { CoreAdoptionContext } from 'context/CoreAdoption'

export default function Accelerator({ ...props }) {
	const { account } = useContext(CoreAdoptionContext)

	return (
		<Section id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle
				title="ARC Accelerator®"
				text="An intervention program designed to provide targeted instruction and practice for students not yet reading on grade level."
			/>
			<Row className="justify-center">
				{!account?.accelerator.includes('ARC Accelerator | Elementary') && (
					<Col className="w-1/3">
						<Resource title="ARC Accelerator | Elementary" protected />
					</Col>
				)}
				{!account?.accelerator.includes('ARC Accelerator | Secondary') && (
					<Col className="w-1/3">
						<Resource title="ARC Accelerator | Secondary" protected />
					</Col>
				)}
			</Row>
		</Section>
	)
}
